import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { sidebarPosts } from '../../data/blogData';

function Sidebar() {
  const [activeTab, setActiveTab] = useState('popular');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;
    navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
  };

  const renderList = (posts) =>
    posts.map((post) => (
      <div className="sidebar-post" key={post.id}>
        <img className="sidebar-thumb" src={post.image} alt={post.title} />
        <div>
          <Link className="sidebar-post-title" to={`/blog/${post.slug}`}>
            {post.title}
          </Link>
          <div className="sidebar-date">{post.date}</div>
        </div>
      </div>
    ));

  return (
    <aside className="col-lg-3 sidebar-wrap">
      <form className="search-form" onSubmit={handleSearch}>
        <input
          className="search-input"
          type="search"
          name="search"
          placeholder="Search..."
          aria-label="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button className="search-button" type="submit" aria-label="Submit search">
          <i className="bi bi-search"></i>
        </button>
      </form>

      <div className="sidebar-tabs">
        <ul className="nav nav-tabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'popular' ? 'active' : ''}`}
              type="button"
              role="tab"
              aria-selected={activeTab === 'popular'}
              onClick={() => setActiveTab('popular')}
            >
              Popular
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'recent' ? 'active' : ''}`}
              type="button"
              role="tab"
              aria-selected={activeTab === 'recent'}
              onClick={() => setActiveTab('recent')}
            >
              Recent
            </button>
          </li>
        </ul>

        <div className="tab-content">
          <div
            className={`tab-pane fade ${activeTab === 'popular' ? 'show active' : ''}`}
            role="tabpanel"
          >
            <div className="sidebar-list">{renderList(sidebarPosts.popular)}</div>
          </div>
          <div
            className={`tab-pane fade ${activeTab === 'recent' ? 'show active' : ''}`}
            role="tabpanel"
          >
            <div className="sidebar-list">{renderList(sidebarPosts.recent)}</div>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
